import { render, staticRenderFns } from "./WarehouseLocationCategorySelect.vue?vue&type=template&id=4ef91e32"
import script from "./WarehouseLocationCategorySelect.vue?vue&type=script&lang=ts"
export * from "./WarehouseLocationCategorySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports